import Swiper, { Navigation, Pagination } from 'swiper';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

(() => {
    let carousels = document.querySelectorAll('[data-carousel]');

    for(let carousel of carousels) {

        let carouselSettings = {};

        // Get the carousel settings, quit out if there's an error in the settings
        try {
            carouselSettings = carousel.dataset.carouselSettings ? JSON.parse(carousel.dataset.carouselSettings) : {};
        } catch(err) {
            console.error('Carousel settings error - ' + err);
            return;
        }

        carouselSettings.pagination = carouselSettings.pagination || {
            el: '.swiper-pagination',
            clickable: true
        };

        carouselSettings.navigation = carouselSettings.navigation || {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }

        const swiper = new Swiper(
            carousel,
            carouselSettings
        )
    }
    
})();